import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=1b96168f&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b96168f')) {
      api.createRecord('1b96168f', component.options)
    } else {
      api.reload('1b96168f', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=1b96168f&", function () {
      api.rerender('1b96168f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2L2lEWG9CdjWE/JS/comp/ImgFallback.vue"
export default component.exports